/* eslint-disable */
import 'src/utilities/react-dom-polyfill'
import ReactQuill from 'react-quill-new'
import 'react-quill-new/dist/quill.snow.css'
import { Box } from '@mui/material'
import { compose } from 'ramda'

// eslint-disable-next-line @typescript-eslint/explicit-module-boundary-types
let Wysiwyg = ({ onChange, defaultValue = '', value = '' }) => {
  let modules = {
    toolbar: [
      ['bold', 'italic', 'underline', 'strike'], // toggled buttons
      ['blockquote', 'code-block'],

      [{ header: 1 }, { header: 2 }], // custom button values
      [{ list: 'ordered' }, { list: 'bullet' }],
      [{ script: 'sub' }, { script: 'super' }], // superscript/subscript
      [{ indent: '-1' }, { indent: '+1' }], // outdent/indent
      [{ direction: 'rtl' }], // text direction

      [{ size: ['small', false, 'large', 'huge'] }], // custom dropdown
      [{ header: [1, 2, 3, 4, 5, 6, false] }],

      [{ color: [] }, { background: [] }], // dropdown with defaults from theme
      [{ font: [] }],
      [{ align: [] }],
      ['link', 'image', 'video'],
      ['clean'],
    ],
    clipboard: {
      // toggle to add extra line breaks when pasting HTML:
      matchVisual: false,
    },
  }

  return (
    <Box
      sx={{
        backgroundColor: 'white',
        color: 'black',
        '& .ql-editor': {
          backgroundColor: (theme) => theme.palette.background.paper,
          color: 'white',
        },
      }}
    >
      {
        <ReactQuill
          value={decodeURI(value)}
          defaultValue={decodeURI(defaultValue)}
          theme="snow"
          onChange={compose(onChange, encodeURI)}
          modules={modules}
        />
      }
    </Box>
  )
}

export default Wysiwyg
